import { isEmpty } from 'lodash'

import validates from 'helpers/validates'

import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const cpf = {
  name: 'cpf',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'CPF inválido') {
    return this.test(
      'cpf',
      message,
      (value) => isEmpty(value) || validates.cpf.isValid(value),
    )
  },
}

export default cpf
